import { render, staticRenderFns } from "./TicketsMailDetail.vue?vue&type=template&id=15c85147&scoped=true"
import script from "./TicketsMailDetail.vue?vue&type=script&lang=js"
export * from "./TicketsMailDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketsMailDetail.vue?vue&type=style&index=0&id=15c85147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c85147",
  null
  
)

export default component.exports